/* eslint-disable no-console */
/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { Logger } from './logger.service';

export const isDebugMode = environment.debug;

const noop = (): any => undefined;

@Injectable()
export class ConsoleLoggerService implements Logger {

    get debug() {
        if (isDebugMode) {
            return console.debug.bind(console);
        } else {
            return noop;
        }
    }
    get info() {
        if (isDebugMode) {
            return console.info.bind(console);
        } else {
            return noop;
        }
    }

    get warn() {
        return console.warn.bind(console);
    }

    get error() {
        return console.error.bind(console);
    }

    get trace() {
        return console.trace.bind(console);
    }
}
